import {
  commitMutation,
  graphql
} from 'react-relay';

import environment from '../Environment';

const mutation = graphql`
mutation AccountUpdateCommercialManagerMutation($commercialManagerEmail: String!, $email: String!) {
  accountUpdateCommercialManager(commercialManagerEmail: $commercialManagerEmail, email: $email) { 
    ok
    error
  }
}
`;

export default ({
  id,
  email,
  commercialManagerEmail,
  update
}, done) => {

  const variables = {
    email,
    commercialManagerEmail
  };

  commitMutation(
    environment,
    {
      mutation,
      variables,
      updater: (proxyStore, { accountUpdateCommercialManager: { ok } }) => {
        if (ok && update) {
          const account = proxyStore.get(id);
          const extra = account.getLinkedRecord('extra');
          extra.setValue(commercialManagerEmail, 'commercialManagerEmail');
          account.setLinkedRecord(extra, 'extra');
        }
      },
      optimisticUpdater: () => {
      },
      onCompleted: (response) => {
        const { ok, error } = response.accountUpdateCommercialManager;
        done(ok, error);
      },
      onError: error => console.error(error)
    }
  );
};
